export default {
  en: {
    privacy_implication: "Privacy Implication",
    enumeration_name: "{0} Enumeration",
  },
  es : {
    privacy_implication: "Implicación de Privacidad",
    enumeration_name: "Enumeración {0}",
  },
  ca : {
    privacy_implication: "Implicació de Privacitat",
    enumeration_name: "Enumeració {0}",
  }
};
